import React, {Component} from 'react'
import {extlink, outbound} from '../analytics/outbound'

const styles = {
  copy: {
    position: `relative`,
    //top: `-0.9em`,
    padding: `0px 15px 10px 15px`,
    fontSize: `calc(1em + 8pt)`,
  },
}

export default class Footer extends Component {
  render() {
    return <div style={styles.copy}>
      &copy; 2018, IdeaFounder, Seattle, WA &#160;&#160;
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/footer/index.js